document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.custom-cart-recommendations');
  
  if (container && container.dataset.baseProductId && container.dataset.baseProductId !== "") {
    fetchRecommendationsById(container.dataset.baseProductId, container);
  } else {
    fetchCartRecommendationsDynamic();
  }
  
  observeCartUpdates();
});

// 1. DIRECT FETCH (✅ Limit badha di hai aur Debugging logs add kiye hain)
async function fetchRecommendationsById(productId, container) {
  try {
    // Ye line aapko batayegi ki kis ID ke liye product dhoonda ja raha hai
    console.log("Fetching recommendations for Product ID:", productId); 
    
    // Limit 4 se badha kar 10 kar di hai
    const response = await fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=10&intent=related`);
    const { products } = await response.json();

    // Ye line dikhayegi ki Shopify backend se kon se products wapas aaye
    console.log("Returned Products from Shopify API:", products); 

    if (products && products.length > 0) {
      renderRecommendations(products, container);
      container.style.display = 'block'; 
      attachSliderNav();
      attachMouseDragScroll();
    } else {
      container.style.display = 'none';
    }
  } catch (error) {
    console.error('Error fetching recommendations:', error);
  }
}

// 2. DYNAMIC FETCH
async function fetchCartRecommendationsDynamic() {
  const container = document.querySelector('.custom-cart-recommendations');
  if (!container) return;

  try {
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartResponse.json();

    if (cart.items.length === 0) {
      container.style.display = 'none';
      return;
    }

    const productId = cart.items[0].product_id;
    await fetchRecommendationsById(productId, container);
    
  } catch (error) {
    console.error('Error fetching dynamic recommendations:', error);
  }
}

// 3. OBSERVER
function observeCartUpdates() {
  const originalFetch = window.fetch;
  window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);
    const url = arguments[0];
    
    if (url && typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
      setTimeout(() => {
        fetchCartRecommendationsDynamic();
      }, 300); 
    }
    return response;
  };
}

// 4. RENDER HTML
function renderRecommendations(products, container) {
  const listContainer = container.querySelector('#CartRecommendationsList');
  if (!listContainer) return;
  
  let html = '';
  products.forEach(product => {
    const price = (product.price / 100).toFixed(2);
    const imageSrc = product.images.length > 0 ? product.images[0] : '';
    html += `
      <div class="rec-product-card">
        <div class="rec-image-wrapper">
          <img src="${imageSrc}" alt="${product.title}">
        </div>
        <div class="rec-product-info">
          <p class="rec-title">${product.title}</p>
          <p class="rec-price">$${price}</p>
          <button class="rec-quick-add" data-variant-id="${product.variants[0].id}">Quick Add</button>
        </div>
      </div>
    `;
  });
  listContainer.innerHTML = html;
  attachQuickAddListeners();
}

// 5. SLIDER NAV + ARROW STATE 
function attachSliderNav() {
  const slider = document.getElementById('CartRecommendationsList');
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');

  if (!slider || !prevBtn || !nextBtn) return;

  const newPrevBtn = prevBtn.cloneNode(true);
  const newNextBtn = nextBtn.cloneNode(true);
  prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
  nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);

  let isAtStart = true;
  let isAtEnd = false;

  function updateArrowStates() {
    const scrollWidth = Math.round(slider.scrollWidth);
    const clientWidth = Math.round(slider.clientWidth);
    const scrollLeft = Math.round(slider.scrollLeft); 
    const maxScroll = scrollWidth - clientWidth;

    // Arrows tab hide ho jayenge agar koi scroll zaroorat nahi hai
    if (scrollWidth <= clientWidth + 5) { 
      newPrevBtn.style.display = 'none';
      newNextBtn.style.display = 'none';
      return; 
    } else {
      newPrevBtn.style.display = ''; 
      newNextBtn.style.display = '';
    }

    isAtStart = scrollLeft <= 5;
    isAtEnd = scrollLeft >= maxScroll - 5;

    // Left arrow styling
    if (isAtStart) {
      newPrevBtn.style.backgroundColor = '#FFFAF4';
      newPrevBtn.style.color = '#7A4E2D';
      newPrevBtn.style.border = '1px solid #7A4E2D';
      newPrevBtn.style.cursor = 'not-allowed';
      newPrevBtn.style.opacity = '0.5'; 
    } else {
      newPrevBtn.style.backgroundColor = '#7b5836';
      newPrevBtn.style.color = 'white';
      newPrevBtn.style.border = 'none';
      newPrevBtn.style.cursor = 'pointer';
      newPrevBtn.style.opacity = '1';
    }

    // Right arrow styling
    if (isAtEnd) {
      newNextBtn.style.backgroundColor = '#FFFAF4';
      newNextBtn.style.color = '#7A4E2D';
      newNextBtn.style.border = '1px solid #7A4E2D';
      newNextBtn.style.cursor = 'not-allowed';
      newNextBtn.style.opacity = '0.5';
    } else {
      newNextBtn.style.backgroundColor = '#7b5836';
      newNextBtn.style.color = 'white';
      newNextBtn.style.border = 'none';
      newNextBtn.style.cursor = 'pointer';
      newNextBtn.style.opacity = '1';
    }
  }

  setTimeout(updateArrowStates, 150);

  slider.addEventListener('scroll', updateArrowStates);
  window.addEventListener('resize', updateArrowStates);

  let isAnimating = false;

  newPrevBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (isAnimating || isAtStart) return; 
    
    isAnimating = true;
    const cardWidth = slider.querySelector('.rec-product-card') ? slider.querySelector('.rec-product-card').offsetWidth : 130;
    slider.scrollBy({ left: -(cardWidth + 10), behavior: 'smooth' });

    setTimeout(() => { 
      isAnimating = false; 
      updateArrowStates();
    }, 400);
  });

  newNextBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (isAnimating || isAtEnd) return; 
    
    isAnimating = true;
    const cardWidth = slider.querySelector('.rec-product-card') ? slider.querySelector('.rec-product-card').offsetWidth : 130;
    slider.scrollBy({ left: (cardWidth + 10), behavior: 'smooth' });

    setTimeout(() => { 
      isAnimating = false; 
      updateArrowStates();
    }, 400);
  });
}

// 6. MOUSE DRAG SCROLL
function attachMouseDragScroll() {
  const slider = document.getElementById('CartRecommendationsList');
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', function(e) {
    isDown = true;
    slider.style.cursor = 'grabbing';
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    e.preventDefault();
  });

  slider.addEventListener('mouseleave', function() {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mouseup', function() {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;
    slider.scrollLeft = scrollLeft - walk;
  });
}

// 7. QUICK ADD - Taste Theme
function attachQuickAddListeners() {
  const addButtons = document.querySelectorAll('.rec-quick-add');
  addButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const button = this;
      button.innerText = 'Adding...';
      button.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'items': [{ 'id': variantId, 'quantity': 1 }] })
      })
      .then(response => response.json())
      .then(addedData => {
        button.innerText = 'Added!';

        fetch(window.Shopify.routes.root + 'cart.js')
          .then(r => r.json())
          .then(cart => {

            if (typeof publish === 'function') {
              publish('cart-update', { cart: cart });
            }

            const cartDrawerEl = document.querySelector('cart-drawer');
            if (cartDrawerEl) {
              if (typeof cartDrawerEl.renderContents === 'function') {
                cartDrawerEl.renderContents({ cart: cart });
              }
            }

            document.querySelectorAll('.cart-count-bubble').forEach(el => {
              el.classList.remove('hidden');
              const hiddenSpan = el.querySelector('[aria-hidden="true"]');
              const visibleSpan = el.querySelector('.visually-hidden');
              if (hiddenSpan) hiddenSpan.textContent = cart.item_count;
              if (visibleSpan) visibleSpan.textContent = `${cart.item_count} items`;
            });

          });

        setTimeout(() => { 
          button.innerText = 'Quick Add';
          button.disabled = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error:', error);
        button.innerText = 'Error';
        button.disabled = false;
      });
    });
  });
}